import { Theme, Grid, Paper, Container } from '@mui/material';
import { createStyles, withStyles } from '@mui/styles';
import { GridColumnVisibilityModel, GridSortDirection, GridSortItem, GridSortModel } from '@mui/x-data-grid';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Paging from '../../interfaces/common/paging';
import { RootState } from '../../setup';
import Pagination from '../../interfaces/common/pagination';
import IMenuItem from '../../interfaces/common/menuItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MainLayout from '../common/widgets/mainLayout';
import PageUtils from '../../utils/pageUtils';
import LanguageUtils from '../../utils/LanguageUtils';
import Seller from '../../interfaces/output/seller';
import { fetchSellers, getSellers, isLoadingSellers, resetSellers } from '../../reducers/sellerReducer';
import SellersList from './sellersList';
import UrlConstants from '../../constants/UrlConstants';
import ActionRenderer from '../common/actionRenderer';

interface ISellersProps {
    sellers: Pagination<Seller>;
    classes: any;
    fetchSellers: any;
    isLoading: boolean;
    onChange: () => void;
    resetSellers: () => void;
}

interface ISellerState {
    paging: Paging;
    menuItem: IMenuItem;
    sortModel: GridSortModel;
    columnVisibilityModel: GridColumnVisibilityModel;
}

const messages = {
    sellers: LanguageUtils.createMessage('Sellers'),
    add: LanguageUtils.createMessage('Add')
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchSellers: (paging: Paging) => dispatch(fetchSellers({ paging })),
    resetSellers: () => dispatch(resetSellers())

});

const mapStoreToProps = (store: RootState) => {
    return {
        sellers: getSellers(store),
        isLoading: isLoadingSellers(store)
    };
};

const styles = (theme: Theme) => createStyles({
    container: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    paper: {
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column'
    }
});

class Sellers extends Component<ISellersProps, ISellerState> {
    sellersListRef: any;
    constructor(props: ISellersProps) {
        super(props);
        this.sellersListRef = React.createRef();

        this.state = {
            paging: PageUtils.getDefaultPaging(),
            menuItem: {
                id: 1,
                name: messages.sellers,
                icon: <FontAwesomeIcon icon="user-friends" size="1x" transform="grow-7" />,
                isSelected: false
            },
            sortModel: [{
                field: '',
                sort: '' as GridSortDirection
            } as GridSortItem],
            columnVisibilityModel: {}
        };
    }

    componentDidMount() {
        const { fetchSellers } = this.props;
        const { paging } = this.state;

        fetchSellers(paging);
    }

    componentWillUnmount() {
        const { resetSellers } = this.props;
        resetSellers();
    }

    _onSortChange = (newModel: GridSortModel) => {
        const { fetchSellers } = this.props;
        const { sortModel, paging } = this.state;

        if(JSON.stringify(sortModel) !== JSON.stringify(newModel)) {
            const newPaging = {
                ...paging,
                sort: newModel
            };

            this.setState({
                sortModel: newModel,
                paging: newPaging
            });

            fetchSellers(newPaging);

        }
    }

    render() {
        const { classes, sellers, fetchSellers, isLoading } = this.props;
        const { paging, menuItem, columnVisibilityModel } = this.state;

        return (
            <MainLayout menuItem={menuItem}>
                <Container maxWidth="xl" className={classes.container}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Paper className={classes.paper}>
                                <Grid container direction="column">
                                    <Grid item pt={1} mr={3}>
                                        <Grid container direction="row" justifyContent="flex-end">
                                            <ActionRenderer actions={[{
                                                text: messages.add,
                                                icon: 'plus',
                                                href: `${UrlConstants.SELLERS}/add`
                                            }]} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <br/>
                                <SellersList rows={sellers} isLoading={isLoading}
                                    ref={this.sellersListRef}
                                    onPageChange={(nextPage: number, nextSize: number) => {
                                        const newPage = {
                                            ...paging,
                                            page: nextPage,
                                            size: nextSize
                                        };
                                        fetchSellers(newPage);
                                        this.setState({ paging: newPage });
                                    }}
                                    onSortModelChange={(sortModel: GridSortModel) => this._onSortChange(sortModel)}
                                    columnVisibilityModel={columnVisibilityModel}
                                    onColumnVisibilityModelChange={(newModel: GridColumnVisibilityModel) =>
                                        this.setState({
                                            columnVisibilityModel: newModel
                                        })
                                    }
                                />
                            </Paper>
                        </Grid>
                    </Grid>
                </Container>
            </MainLayout>
        );
    }
}

export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(Sellers));